import { useQuery } from '@tanstack/react-query';
import { ROUTES, type Me } from '@serb/shared';
import { api, ApiError } from '../../api/client';
import { KEYS } from '../../api/keys';

/** Who is signed in; null = nobody (show the login page) */
export function useMe() {
  return useQuery({
    queryKey: KEYS.me,
    queryFn: async (): Promise<Me | null> => {
      try {
        return await api.get<Me>(ROUTES.api.me);
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
  });
}
